/** Routes du module — propriétaire : Agent A4 — Sécurité (compte, entreprise, utilisateurs client). Contrat : exporter `routesProCompte` et `navProCompte`. */
import type { RouteObject } from 'react-router';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { PageDonneesPersonnelles, PageMonCompte } from './Compte';
import { PageEntreprise } from './Entreprise';

export const routesProCompte: RouteObject[] = [
  { path: 'compte', element: <PageMonCompte /> },
  { path: 'entreprise', element: <PageEntreprise /> },
  { path: 'entreprise/adresses', element: <PageEntreprise onglet="adresses" /> },
  { path: 'entreprise/utilisateurs', element: <RequirePermission permission="entreprise.utilisateurs.gerer"><PageEntreprise onglet="utilisateurs" /></RequirePermission> },
  { path: 'donnees-personnelles', element: <RequirePermission permission="rgpd.demande.propre"><PageDonneesPersonnelles /></RequirePermission> },
];

export const navProCompte: EntreeNav[] = [
  { libelle: 'Entreprise', vers: '/pro/entreprise', permission: 'portail.acces' },
  { libelle: 'Mon compte', vers: '/pro/compte', permission: 'portail.acces' },
];
